<template>
  <div>
    <div class="outer-wrapper" :style="{width:main_width}">
      <div class="m-option-wrapper">
        <div class="button-wrapper">
          <div class="keyword-input-wrapper">
            <label class="keyword-label">
              关键字：
              <Input v-model="optionData.keyword" placeholder="请输入..." clearable class="keyword-input" />
            </label>
          </div>
          <Button class="main-button" type="primary" icon="ios-search" @click="go_search">查找</Button>
        </div>
      </div>
      <div class="table-wrapper" id="data-list">
            <list-with-page
              :Tpage="tableList.Tpage"
              :loading="tableList.loading"
              :columns_t="columnsFormatData"
              :totalItems="tableList.totalItems"
              :no_data_text="tableList.no_data_text"
              :tivdata="tableList.tableListData"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
              v-model="selected"
            ></list-with-page>
      </div>
    </div>
  </div>
</template>
<script>
import listWithPage from "./ListWithPage.vue";
//import { constants } from 'crypto';
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "simpleList",
  components: {
    listWithPage,
  },
  props: {
    "columnsFormatData":{
        type:Array,
        required:true,
    },
    "uri_name":{
        type:String,
        default:'/ask_list_data'
    },
    "main_width":{
        type:String,
        default:''
    },
    'askData':{
        type:String,
        required:true
    },
    'refreshData':{
        type:Number,
        default:1
    },
    'selectedRow':{
      type:Array,
      default:function(){
        return [];
      }
    }
    },
  model:{
    prop:'selectedRow',
    event:'on-selection-change'
  },
  data() {
    return {
        tableList:{
            Tpage: {
                currentPage: 1,
                currentSize: 20
            },
            totalItems: 0,
            no_data_text: "",
            loading: true,
            columns_t: this.columns_data,
            tableListData: [],
        },
        optionData:{
            keyword: "",
        },
      selected:this.selectedRow,
    };
  },
  computed: {
  },
  mounted() {
    this.get_data();
  },
  watch:{
      refreshData:{
        immediate: true,
        handler(){
          this.get_data();
          this.selected = [];
        }
      },
      selected:function(){
        this.$emit('on-selection-change',this.selected);
      }
  },
  methods: {
    get_data() {
      this.tableList.loading = true;
      this.tableList.no_data_text = "数据加载中...";
      this.$axios
        .post(this.$url + this.uri_name, {
          page: this.tableList.Tpage,
          ask_data:this.askData,
          keyword: this.optionData.keyword,
          userToken: userToken
        })
        .then(
          response => (
            (this.tableList.tableListData = response.data.res_record),
            (this.tableList.totalItems = response.data.total_n),
            (this.tableList.loading = false),
            (this.tableList.no_data_text = "暂无数据")
          )
        );
    },
    handleCurrentChange(value) {
      this.tableList.Tpage.currentPage = value;
      this.get_data();
    },
    handleSizeChange(value) {
      this.tableList.Tpage.currentSize = value;
      this.tableList.Tpage.currentPage = 1;
      this.get_data();
    },
    go_search() {
      this.tableList.Tpage.currentPage = 1;
      this.get_data();
      this.selected = [];
    },
  },  
};
</script>
<style scoped>
.outer-wrapper {
  width: 1260px;
  margin: 0 auto;
}

.m-option-wrapper {
  box-shadow: 2px 2px 1px #aaaaaa;
  border: 1px solid #e7e7e7;
  padding: 2px;
  overflow: hidden;
  padding-top:30px;
}

.button-wrapper {
  text-align: right;
  height: 50px;
}

.main-button {
  margin-right: 30px;
}

.main-button {
  background-color: #993333;
  color: #ddd;
  border: none;
}

.main-button:hover {
  background-color: #993333;
  border: none;
  color: #fff;
}

.re-button {
  margin-right: 6%;
}

.table-wrapper {
  margin-top: 10px;
  box-shadow: 2px 2px 1px #aaaaaa;
  border: 1px solid #e7e7e7;
  padding: 0 10px;
  overflow: hidden;
}

.echarts-wrapper {
  margin: 0 auto;
}

.keyword-input-wrapper {
  float: left;
  margin-left: 20px;
}

.keyword-label {
  color: #999;
  font-size: 14px;
}

.keyword-input {
  width: 350px;
  margin-left: 20px;
}

.ins-wrapper {
  font-size: 16px;
  padding: 20px 50px;
  text-align: center;
}

.navImg {
  margin: 0 auto;
  width: 800px;
}

.pane_label {
  font-size: 15px;
  font-weight: 800;
}

.catagory-option-wrapper {
  border: 2px dashed #b4a078;
  margin: 10px 20px;
  padding: 10px 0;
  overflow: hidden;
}

.option-title-wrapper {
  color: #006699;
  font-size: 14px;
  font-family: SimHei;
  text-align: center;
  padding-top: 10px;
  font-weight: 700;
}

.title-box {
  border-left: 1px solid #006699;
  border-right: 1px solid #006699;
  padding: 0 15px;
}

.single-chart-wrapper {
  margin-bottom: 30px;
}
</style>